import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler, clearCreds, getCreds } from 'common/helpers';
import { SocketIOService } from 'common/SocketIoService';
import { IRootModel } from 'app/store';
import { IAuthPayload } from 'entities/Auth/Auth.models';
import { authService } from 'entities/Auth/Auth.service';
import { saveAuthCreds } from 'entities/Auth/Auth.helper';

export const authEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async initAuth() {
    const creds = await getCreds();

    if (creds) {
      const now = Math.round(Date.now() / 1000);

      if (creds.refresh && creds.refresh.expiredAt < now) {
        clearCreds();
        dispatch.auth.setLoading(false);
        return;
      }

      if (creds.access && creds.access.expiredAt < now) {
        if (creds.refresh && creds.refresh.token) {
          await dispatch.auth.refreshToken(creds.refresh.token);
          return;
        } else {
          clearCreds();
          return;
        }
      }

      SocketIOService.connect(creds.access?.token as string);
      dispatch.auth.setAuth(creds);
    }

    dispatch.auth.setLoading(false);
  },
  async login(payload: IAuthPayload) {
    dispatch.auth.setLoading(true);

    await authService
      .login(payload)
      .then((response) => {
        saveAuthCreds(dispatch, response);
        SocketIOService.connect(response.access_token);
      })
      .catch(axiosErrorHandler)
      .finally(() => {
        dispatch.auth.setLoading(false);
      });
  },
  async refreshToken(refreshToken: string) {
    dispatch.auth.setLoading(true);
    SocketIOService.disconnect();

    return await authService
      .refreshToken(refreshToken)
      .then((response) => {
        saveAuthCreds(dispatch, response);
        SocketIOService.connect(response.access_token);
        return response.access_token;
      })
      .catch((error) => {
        axiosErrorHandler(error);
        dispatch.auth.logout();
      })
      .finally(() => {
        dispatch.auth.setLoading(false);
      });
  },
  async logout() {
    clearCreds();
    dispatch.auth.clearAuth();
    dispatch.auth.setLoading(false);
    SocketIOService.disconnect();
  },
});
